
import {configureStore} from '@reduxjs/toolkit'


import postReducers from '../features/posts/posts'
import userReducers from '../features/userAuth/userAuth'

export const store = configureStore({
 reducer:{
     posts: postReducers,
     user: userReducers,
 }
})